// REST backend transport flags. When REST_BACKEND_URL is set the client routes
// callApi through the REST provider instead of the GramJS/MTProto worker path.
export const REST_BACKEND_URL = (process.env.REST_BACKEND_URL || '').replace(/\/$/, '');
export const REST_WS_URL = process.env.REST_WS_URL || '';
export const IS_REST_PROVIDER = Boolean(REST_BACKEND_URL);
export const CLIENT_FEATURES = 'trainingRecording';
